import { classNames } from "@circle-react/helpers/twMergeWithCN";
import type { PropsWithChildren } from "react";

interface GridColumnsProps {
  className?: string;
  dataTestId?: string;
}

export const GridColumns = ({
  children,
  className,
  dataTestId,
}: PropsWithChildren<GridColumnsProps>) => (
  <div
    className={classNames(
      "flex w-full flex-col lg:grid lg:grid-cols-2",
      className,
    )}
    data-testid={dataTestId}
  >
    {children}
  </div>
);
